import { useState, type ReactNode } from 'react';
import Eyebrow from './Eyebrow';
import Squiggle from './Squiggle';

interface FaqItem {
  q: string;
  a: ReactNode;
}

const ITEMS: FaqItem[] = [
  {
    q: 'Le test de positionnement a-t-il lieu samedi ?',
    a: "Non. La JPO est dédiée à la visite et aux animations. Le test de positionnement se passe en semaine, sur rendez-vous fixé après votre visite — 20 à 30 minutes en conditions sereines, pas un quiz expédié sur place. Vous recevez un rapport personnalisé écrit sous 48 heures, avec le niveau de votre enfant matière par matière et nos recommandations. Le test concerne les élèves de primaire (CP à CE6) ; pour la maternelle, c'est une rencontre avec les éducatrices.",
  },
  {
    q: 'Faut-il payer quelque chose ?',
    a: 'Tout est gratuit : visite, animations, restauration légère, et le test de positionnement si vous en faites la demande après la JPO. Aucun frais à prévoir.',
  },
  {
    q: "Suis-je obligé d'inscrire mon enfant après ?",
    a: "Non. Le test sert à vous donner un retour sur le niveau de votre enfant. La décision d'inscription reste entièrement libre.",
  },
  {
    q: 'Mon enfant est timide ou très jeune, est-ce un problème ?',
    a: "Pas du tout. Nos équipes sont habituées à la maternelle et au primaire. Tout se fait dans un cadre rassurant, parent présent si l'enfant le souhaite.",
  },
  {
    q: 'Comment trouver les campus ?',
    a: (
      <>
        Adresse principale&nbsp;: 364 boulevard Oum Rabia, Oulfa, Casablanca, 20220.{' '}
        <a
          href="https://maps.app.goo.gl/T6cABrSAyGHhRXkY6"
          target="_blank"
          rel="noopener noreferrer"
          className="faq-link"
        >
          Voir sur Google Maps →
        </a>
      </>
    ),
  },
];

const Faq = () => {
  const [open, setOpen] = useState<number>(0);

  return (
    <section className="faq">
      <div className="container faq-container">
        <div className="faq-head">
          <Eyebrow>Vos questions</Eyebrow>
          <h2 className="section-title">
            On a anticipé
            <br />
            <span className="section-title-emph">
              vos questions.
              <Squiggle className="title-squiggle" />
            </span>
          </h2>
        </div>

        <ul className="faq-list">
          {ITEMS.map((it, i) => {
            const isOpen = i === open;
            return (
              <li key={it.q} className={`faq-item ${isOpen ? 'is-open' : ''}`}>
                <button
                  type="button"
                  className="faq-q"
                  aria-expanded={isOpen}
                  onClick={() => setOpen(isOpen ? -1 : i)}
                >
                  <span className="faq-q-num">{String(i + 1).padStart(2, '0')}</span>
                  <span className="faq-q-text">{it.q}</span>
                  <span className="faq-q-icon" aria-hidden="true">
                    <svg
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="currentColor"
                      strokeWidth="2"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <polyline points="6 9 12 15 18 9" />
                    </svg>
                  </span>
                </button>
                <div className="faq-a-wrap">
                  <p className="faq-a">{it.a}</p>
                </div>
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
};

export default Faq;
